var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditMatrix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02494 9.01494C4.83691 7.65422 3.58566 6.70681 2.22494 6.89485C0.864233 7.08289 -0.0831808 8.33414 0.104858 9.69485C0.292896 11.0556 1.54415 12.003 2.90486 11.8149C4.26557 11.6269 5.21298 10.3756 5.02494 9.01494ZM9.0611 0.595607C8.58777 0.472032 8.09474 0.442895 7.61015 0.50986C5.57293 0.791387 4.1485 2.67264 4.43002 4.70986C4.56526 5.68853 5.08374 6.57338 5.87139 7.16977C6.65905 7.76616 7.65135 8.02523 8.63002 7.88999C10.6672 7.60847 12.0917 5.72722 11.8102 3.68999C11.7432 3.20541 11.5814 2.73875 11.3341 2.31668C11.0868 1.89461 10.7588 1.52538 10.3688 1.23008C9.97877 0.934775 9.53442 0.719182 9.0611 0.595607Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.178 8.55214L12.5184 8.89258L9.23035 12.1738H8.8972V11.8406L12.178 8.55214ZM13.4816 6.37915C13.3911 6.37915 13.2969 6.41537 13.2281 6.48418L12.5654 7.14694L13.9234 8.50506L14.586 7.8423C14.7273 7.70106 14.7273 7.46565 14.586 7.33165L13.7387 6.48418C13.6663 6.41175 13.5757 6.37915 13.4816 6.37915ZM12.178 7.53446L8.17297 11.54V12.8981H9.53091L13.5359 8.89258L12.178 7.53446Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMatrix);
export default __webpack_public_path__ + "static/media/editMatrix.72541881.svg";
export { ForwardRef as ReactComponent };